import React, { useEffect,useState } from 'react';
import TemplateNames from './TemplateNames';
import TemplateContent from './TemplateContent';
import TemplateButton from './TemplateButton';
import Preview from './Preview';
import AuthenticationBody from './AuthenticationBody';
import UtilityValidation from './UtilityValidation';

const Authentication = ({template,setTemplate,selectedCategory,selectedSubCat,showPreview,setShowPreview}) => {

  const [mediaPreview,setMediaPreview]=useState(null)
  const [varType,setVarType]=useState("Number")

  return (
     <div className="flex h-screen bg-gradient-to-br from-purple-50 to-gray-90">
      {/* Left Side */}
      <div className="flex-1 flex flex-col p-5 overflow-y-auto">
        
        <TemplateNames 
          template={template}
          setTemplate={setTemplate}
          selectedSubCat={selectedSubCat}
          selectedCategory={selectedCategory}
        />
          
          <AuthenticationBody 
          
          setTemplate={setTemplate}
          template={template}
          />
          <UtilityValidation />

      </div>
 
      {/* Right Side (Preview) */}
      <div className="w-1/3 border-l  border-gray-200 bg-gradient-to-br from-purple-50 to-gray-90 p-5 flex-shrink-0">
        <Preview 
          template={template}
          
        />
      </div>
    </div>
          
  );
}

export default Authentication;
